export default __webpack_public_path__ + "static/media/ep27.84397458.png";